import React from 'react'
import AppDialog from 'components/AppDialog'
import { message } from 'antd'
import api, { MetadataEntity } from 'api'
interface Props {
	mode: number
	afterSave?: () => void
}

export default class ModelingCreateNewApp extends React.Component<Props> {
	saveFormData = async () => {
		// let metadataEntity: MetadataEntity = this.refForm.current.getData()
		// if (!metadataEntity) return
		// let res = await api.modeling.entity.createTable(metadataEntity)
		// if (!res) {
		//   return
		// }
		AppDialog.close()
	}

	close = () => {
		AppDialog.close()
	}

	api: any

	render() {
		let metadataEntity = {} as MetadataEntity
		return (
			<div className="app-dialog-form-container">
				{/* <div className="app-dialog-form">
          <AppForm
            formStyle={{ width: '100%' }}
            ref={this.refForm}
            defaultData={metadataEntity}
          >
            <AppInput
              label="应用名称"
              field="appName"
              placeholder="请输入应用名称"
              req
            />
            <AppInput
              label="应用编码"
              field="appCode"
              placeholder="请输入2位应用编码, 例如: 02"
              req
            />
            <AppInput
              label="应用简称"
              field="appAbbreviation"
              placeholder="请输入应用简称"
              req
            />
            <AppInput
              label="排序编号"
              field="sortNum"
              placeholder="请输入排序编号"
              req
            />
          </AppForm>
        </div>
        <AppFormMenu>
          <AppAction title="取消" type="default" action={() => this.close()} />
          <AppAction
            title="确定"
            type="primary"
            action={() => this.saveFormData()}
          />
        </AppFormMenu> */}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/ModelingCreateNewApp.tsx